import { render, staticRenderFns } from "./OnboardingChecklistView.vue?vue&type=template&id=366f0522&scoped=true"
import script from "./OnboardingChecklistView.vue?vue&type=script&lang=ts"
export * from "./OnboardingChecklistView.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingChecklistView.vue?vue&type=style&index=0&id=366f0522&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "366f0522",
  null
  
)

export default component.exports